import React from 'react';
import { CONNECTORS } from '../../services/connectors';
import { ChannelIcon } from './channelIcons';

type Conn = { facebook?: boolean; telegram?: boolean; reddit?: boolean };

// A clean list of live channels — icon · name · status · action.
// Clicking the action opens that channel's setup in a slide-over drawer.
export default function ChannelList({
  connections, onOpen,
}: { connections: Conn; onOpen: (id: string) => void }) {
  const live = CONNECTORS.filter(c => c.status === 'live');

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm divide-y divide-gray-50">
      {live.map(c => {
        const connected = !!(connections as any)[c.id];
        return (
          <div key={c.id} className="flex items-center gap-4 px-5 py-4">
            <ChannelIcon id={c.id} className="w-6 h-6 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-gray-900">{c.name}</p>
              <p className="text-xs text-gray-500 truncate">{c.blurb}</p>
            </div>
            <span className={`hidden sm:inline-flex items-center gap-1.5 text-xs font-medium flex-shrink-0 ${connected ? 'text-emerald-600' : 'text-gray-400'}`}>
              <span className={`w-1.5 h-1.5 rounded-full ${connected ? 'bg-emerald-500' : 'bg-gray-300'}`} />
              {connected ? 'Connected' : 'Not connected'}
            </span>
            <button onClick={() => onOpen(c.id)}
              className="flex-shrink-0 px-3.5 py-1.5 rounded-lg text-sm font-medium border border-gray-200 text-gray-700 hover:bg-gray-50">
              {connected ? 'Manage' : 'Connect'}
            </button>
          </div>
        );
      })}
    </div>
  );
}
